import { Route, setDisabledPagePayload } from '@usacsmideo/types';
import { db } from '../../../constants/firebaseModular';
import { doc, updateDoc } from 'firebase/firestore';

export const setDisabledPage = (payload: setDisabledPagePayload) => {
  // FIND THE PAGE IN THE NAVIGATION OBJECT
  const page = payload.patientInfo.navObj[payload.name as keyof typeof payload.patientInfo.navObj] as Route;
  const updated = structuredClone(page);
  // ENABLE/DISABLE THE PAGE
  updated.disabled = payload.value;
  // UPDATE THE NAVIGATION OBJECT IN FIRESTORE
  const docRef = doc(db, 'users', payload.patientInfo.uid);
  const fieldString = `navObj.${payload.name}`;
  updateDoc(docRef, {
    [fieldString]: updated,
  });
};
